/** WAI-ARIA attributes */
export const ARIA_LABEL = "aria-label";